import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import ModalBaseSm from '../../modals/modal-base-sm';
import axios from '../../../utils/axiosConfig';
import FormModalCreateAgencia from '../forms/formModalCreateAgencia';
import Swal from 'sweetalert2';

const ModalAgencias = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [agencias, setAgencias] = useState([]);
    const [descripcion, setDescripcion] = useState('');

    const [dialogOpen, setDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const [idEdit, setIdEdit] = useState(-1);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return agencias;
        return agencias.filter(item =>
            Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            )
        );
    }, [agencias, debouncedTerm]);

    const toggleDialog = () => {
        setDialogOpen(!dialogOpen);
        limpiarCampos();
    };

    const listarAgencias = () => {
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/getagencias',
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    console.log(
                        'Agencias cargadas:',
                        res.data.data.recordset
                    );
                    setAgencias(res.data.data.recordset);
                } else {
                    Swal.fire(
                        'Error',
                        'No se pudo cargar agencias',
                        'error'
                    );
                }
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'Falla de red al cargar lista',
                    'error'
                )
            );
    };

    const guardar = ({ descripcion }) => {
        if (!descripcion.trim()) {
            Swal.fire(
                'Error',
                'Debe completar la Descripción',
                'error'
            );
            return;
        }
        const payloadCreate = {
            ID: -1,
            Descripcion: descripcion,
        };
        console.log('Payload a subir para crear:', payloadCreate);
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/setagencia',
                JSON.stringify(payloadCreate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                    return;
                }
                console.log('Agencia guardada:', res.data);
                Swal.fire(
                    'Éxito',
                    'Agencia guardada',
                    'success'
                );
                listarAgencias();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire('Error', 'No se pudo guardar', 'error')
            );
    };

    const update = ({ descripcion }) => {
        console.log('Actualizando agencia con ID:', idEdit);
        if (!descripcion.trim()) {
            Swal.fire(
                'Error',
                'Debe completar la Descripción',
                'error'
            );
            return;
        }
        const payloadUpdate = {
            ID: idEdit,
            Descripcion: descripcion,
        };
        console.log('Payload a subir para actualizar:', payloadUpdate);
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones2/setagencia',
                JSON.stringify(payloadUpdate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire(
                        'Error',
                        'No se pudo actualizar',
                        'error'
                    );
                    return;
                }
                console.log('Agencia actualizada:', res.data);
                Swal.fire(
                    'Éxito',
                    'Agencia actualizada',
                    'success'
                );
                listarAgencias();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'No se pudo actualizar',
                    'error'
                )
            );
    };

    const handleSaveOrUpdate = ({ descripcion }) => {
        if (idEdit === -1) {
            guardar({ descripcion });
        } else {
            update({ descripcion });
        }
    };

    const editarAgencia = item => {
        setDescripcion(item.Descripcion);
        setIdEdit(item.IDAgencia);
        setDialogOpen(true);
    };

    const borrarAgencia = item => {
        console.log('Borrando agencia con ID:', item.IDAgencia);
        // pendiente implementación
    };

    const limpiarCampos = () => {
        setDescripcion('');
        setIdEdit(-1);
    };

    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        listarAgencias();
    }, []);

    return (
        <>
            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                    @media (max-width: 575.98px) {
                        .btn-nueva-agencia {
                            width: 100%;
                        }
                    }
                `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar agencia..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nueva-agencia"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nueva Agencia
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '80%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Nombre
                                </th>
                                <th
                                    style={{
                                        color: '#ffffff',
                                        width: '20%',
                                        textAlign: 'center',
                                    }}
                                >
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered?.map((item, i) => (
                                <tr key={i}>
                                    <td
                                        style={{
                                            color: '#000',
                                            textAlign: 'start',
                                        }}
                                    >
                                        {item.Descripcion || '-'}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits)
                                                    editarAgencia(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODAL */}
            <ModalBaseSm
                isOpen={dialogOpen}
                title={
                    idEdit === -1
                        ? 'Crear agencia'
                        : 'Editar agencia'
                }
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateAgencia
                        onSave={handleSaveOrUpdate}
                        initialData={{ descripcion }}
                    />
                }
            />
        </>
    );
};

export default ModalAgencias;
